<template>
	<v-navigation-drawer
		class="sidebar-border media-print modern-sidebar-fixed"
		app
		fixed
		height="100vh"
		hide-overlay
		mini-variant-width="53"
		:mini-variant.sync="mini"
		stateless
		width="250"
		v-model="drawer"
	>
			<!-- ============ MARCA ============ -->
		<div class="sb-marca hide-and-print" :class="{ 'sb-marca--mini': mini }">
			<router-link :to="{ name: nameRoute }" class="sb-marca__logo">
				<img v-if="mini" :src="iconClose" alt="" height="26" class="icon-maki-ocult">
				<img v-else :src="iconOpen" :width="logoWidth" alt="" class="imgLogo">
			</router-link>
			<button
				type="button"
				class="sb-marca__toggle"
				:title="mini ? 'Abrir menú' : 'Colapsar menú'"
				@click.stop="$emit('click-btn-toggle')"
			>
				<v-icon size="18">{{ mini ? 'chevron_right' : 'chevron_left' }}</v-icon>
			</button>
		</div>

		<!-- ============ BUSCADOR ============ -->
		<div v-if="!mini" class="sb-buscador">
			<div class="sb-buscador__caja">
				<v-icon class="sb-buscador__icono">search</v-icon>
				<input
					type="text"
					v-model="search"
					class="sb-buscador__input"
					placeholder="Buscar en el menú"
				>
				<button
					v-if="search"
					type="button"
					class="sb-buscador__limpiar"
					@click="clearSearch"
				>
					<v-icon size="12">close</v-icon>
				</button>
			</div>
		</div>
		<div v-else class="sb-buscador sb-buscador--mini">
			<button
				type="button"
				class="sb-buscador__mini"
				title="Buscar en el menú"
				@click="$emit('click-btn-toggle')"
			>
				<v-icon size="18">search</v-icon>
			</button>
		</div>

		<div v-if="!mini" class="sb-seccion">
			{{ search ? 'Resultados' : 'Menú' }}
		</div>

		<div v-if="filteredItems.length === 0" class="sb-vacio">
			<v-icon size="26" color="rgba(255,255,255,0.6)">search_off</v-icon>
			<span>Sin resultados para &ldquo;{{ search }}&rdquo;</span>
		</div>

		<v-list class="sidebar-bg py-0 modern-menu-list">
			<v-list-group
				v-for="item in filteredItems"
				:key="item.id"
				:value="item.active"
				no-action
				class="modern-menu-group"
			>
				<v-list-tile
					v-if="item.resource.data.length === 0"
					slot="activator"
					:to="item.uri"
					@click.native.stop="$emit('click-list')"
					color="white"
					active-class="white--text modern-active"
					class="modern-single-item enhanced-item"
				>
					<v-list-tile-action class="enhanced-icon-action">
						<v-tooltip right>
							<div class="icon-container" slot="activator">
								<img class="icon-sidebar modern-icon" :src="item.pathIcon">
							</div>
							<span>{{ item.name }}</span>
						</v-tooltip>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title class="modern-menu-title enhanced-title">{{ item.name }}</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>

				<v-list-tile
					v-else
					slot="activator"
					class="padding-items modern-parent-item enhanced-item"
					color="white"
				>
					<v-list-tile-action class="enhanced-icon-action">
						<v-tooltip right>
							<div class="icon-container" slot="activator">
								<img class="icon-sidebar modern-icon" :src="item.pathIcon">
							</div>
							<span>{{ item.name }}</span>
						</v-tooltip>
					</v-list-tile-action>
					<v-list-tile-content class="content-open ml-2 body-2 white--text enhanced-parent-content">
						<v-list-tile-title class="itemName modern-parent-title enhanced-title">{{ item.name }}</v-list-tile-title>
						<v-icon class="enhanced-arrow">keyboard_arrow_down</v-icon>
					</v-list-tile-content>
				</v-list-tile>

				<v-list-tile
					v-for="subItem in item.resource.data"
					:key="subItem.uri"
					:to="{ name: subItem.uri }"
					color="white"
					@click.native.stop="$emit('click-list')"
					class="resources-items modern-sub-item enhanced-sub-item"
					active-class="white--text modern-sub-active"
				>
					<v-list-tile-action class="enhanced-sub-action">
						<v-tooltip right>
							<v-icon
								slot="activator"
								color="white"
								class="title-action modern-dot"
							>lens</v-icon>
							<span>{{ subItem.name }}</span>
						</v-tooltip>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title class="modern-sub-title enhanced-sub-title">{{ subItem.name }}</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list-group>
		</v-list>

		<!-- ============ USUARIO ============ -->
		<div v-if="!mini" class="sb-fade"></div>
		<div v-if="!mini" class="sb-pie">
			<img v-if="userAvatarSideBar" :src="userAvatarSideBar" class="sb-pie__avatar" alt="">
			<div v-else class="sb-pie__avatar sb-pie__avatar--letra">{{ inicialUsuario }}</div>
			<div class="sb-pie__datos">
				<span class="sb-pie__nombre">{{ userName }}</span>
				<span class="sb-pie__estado">
					<i class="sb-pie__punto"></i>
					En línea
				</span>
			</div>
		</div>
		<!-- ============ AVISO: PERMISOS ACTUALIZADOS ============ -->
		<v-dialog :value="permsOutdated" persistent max-width="420">
			<v-card class="perms-sync">
				<div class="perms-sync__icon">
					<v-icon color="white" size="30">sync</v-icon>
				</div>
				<h3 class="perms-sync__title">¡Tus accesos se actualizaron!</h3>
				<p class="perms-sync__text">
					El administrador cambió tus permisos. Actualiza la página para
					que tu menú y tus acciones queden al día. Es rápido, solo toma un segundo.
				</p>
				<div class="perms-sync__actions">
					<button type="button" class="perms-sync__btn" @click="reloadNow">
						<v-icon size="18" color="white">refresh</v-icon>
						Actualizar ahora
					</button>
				</div>
			</v-card>
		</v-dialog>
	</v-navigation-drawer>
</template>

<script>
import helper from '@/shared/helper';
import { mapGetters } from 'vuex';

function normalizarTexto(texto) {
	return `${texto || ''}`
		.toLowerCase()
		.normalize('NFD')
		.replace(/[̀-ͯ]/g, '');
}

function created() {
	const iconOpen = process.env.LOGO_SIDEBAR;
	const iconClose = process.env.LOGO_SIDEBAR_CLOSE;
	this.iconOpen = iconOpen || 'https://maki-bucket1.s3.amazonaws.com/7102C744-A748-4EA2-8B4A-7664ED46F9B5.svg';
	this.iconClose = iconClose || 'https://maki-acl1.s3.amazonaws.com/iconosNew/icon-ocult-makipos.png';
	this.loadData();
	this.startPermissionWatch();
}

function beforeDestroy() {
	this.stopPermissionWatch();
}

function nameRoute() {
	return this.isMibodega ? 'dashboard-report' : 'main';
}

function logoWidth() {
	return this.iconOpen ? '110px' : '65px';
}

function inicialUsuario() {
	return `${this.userName || '?'}`.trim().charAt(0).toUpperCase();
}

// si el padre coincide se muestran todos sus hijos; si solo coinciden hijos, se muestran esos
function filteredItems() {
	const texto = normalizarTexto(this.search).trim();
	if (!texto) {
		return this.items;
	}
	return this.items.map((item) => {
		const hijos = (item.resource.data || [])
			.filter(sub => normalizarTexto(sub.name).indexOf(texto) > -1);
		const coincide = normalizarTexto(item.name).indexOf(texto) > -1;
		if (!coincide && hijos.length === 0) {
			return null;
		}
		const newItem = Object.assign({}, item);
		newItem.resource = Object.assign({}, item.resource, {
			data: coincide ? (item.resource.data || []) : hijos,
		});
		newItem.active = true;
		return newItem;
	}).filter(Boolean);
}

function clearSearch() {
	this.search = '';
}

// Obtiene (sin aplicar) el mapa efectivo del usuario logueado: { uri: [acciones] }.
async function fetchEffectiveResources() {
	const { data: session } = await this.$http.get('company-token');
	const codeCompany = session.companyAcl && session.companyAcl.code_company;
	const codeProject = (session.project && session.project.code_project)
		|| process.env.PROJECT_CODE || 'maki_project';
	const codeApp = (session.app && session.app.code_app) || process.env.APP_CODE;
	const codeUser = session.code_user || session.aclUserCode;
	const sessionRoleId = session.role && session.role.id;
	if (!codeCompany || !codeUser) return {};

	const { data: ovr } = await this.$httpAcl.get(
		`project/${codeProject}/user/${codeUser}/resource-permission`,
		{ params: { codeCompany, codeApp } },
	);
	const ovrData = (ovr && ovr.data) || {};
	let resources = ovrData.permission && ovrData.permission.resources;

	if (!resources) {
		const roleId = ovrData.roleId || sessionRoleId;
		if (roleId) {
			const { data: base } = await this.$httpAcl.get(
				`company/${codeCompany}/role/${roleId}/permission`,
			);
			const perm = base && base.data && base.data.permission;
			resources = perm && perm.resources;
		}
	}
	return resources || {};
}

// Carga y APLICA el permiso efectivo en el store. Fail-open si algo falla.
async function loadEffectivePermissions() {
	try {
		const resources = await this.fetchEffectiveResources();
		this.$perms.setFromResources(resources);
	} catch (err) {
		this.$perms.clear();
	}
}

// Firma estable del mapa de permisos (para comparar si cambió).
function permsSignature(resources) {
	const keys = Object.keys(resources || {}).sort();
	return keys
		.map(k => `${k}:${(resources[k] || []).slice().sort().join(',')}`)
		.join('|');
}

// Revisa si el admin cambió los permisos de este usuario; si sí, avisa.
async function checkPermsSync() {
	if (this.permsOutdated) return;
	try {
		const fresh = await this.fetchEffectiveResources();
		if (permsSignature(fresh) !== permsSignature(this.$perms.map)) {
			this.permsOutdated = true;
			if (this.permsTimer) { clearInterval(this.permsTimer); this.permsTimer = null; }
		}
	} catch (err) {
		// silencioso: si falla la revisión, no molestamos al usuario.
	}
}

// Vigila cada 3 min y al volver a la pestaña.
function startPermissionWatch() {
	this.onWindowFocus = () => this.checkPermsSync();
	window.addEventListener('focus', this.onWindowFocus);
	this.permsTimer = setInterval(() => this.checkPermsSync(), 180000);
}

function stopPermissionWatch() {
	if (this.permsTimer) { clearInterval(this.permsTimer); this.permsTimer = null; }
	if (this.onWindowFocus) {
		window.removeEventListener('focus', this.onWindowFocus);
		this.onWindowFocus = null;
	}
}

function reloadNow() {
	window.location.reload();
}

// Filtra el menú: oculta recursos sin 'read'. Si no hay config, no filtra (fail-open).
function applyPermissionFilter(list) {
	if (!this.$perms.ready || Object.keys(this.$perms.map).length === 0) {
		return list || [];
	}
	const filtered = (list || []).map((item) => {
		const children = (item.resource && item.resource.data) || [];
		if (children.length === 0) {
			return this.$perms.canRead(item.uri) ? item : null;
		}
		const visibles = children.filter(sub => this.$perms.canRead(sub.uri));
		if (visibles.length === 0) return null;
		const newItem = Object.assign({}, item);
		newItem.resource = Object.assign({}, item.resource, { data: visibles });
		return newItem;
	}).filter(Boolean);
	// Red de seguridad: si el filtro dejaría el menú vacío, no filtra.
	return filtered.length ? filtered : (list || []);
}

async function loadData() {
	try {
		await this.loadEffectivePermissions();
		const response = await this.$httpAcl.get(`sidebar/${process.env.APP_CODE}`);
		const source = this.applyPermissionFilter(response.data.data);
		this.items = source.map((item) => {
			const newItem = Object.assign({}, item);
			if (item.resource.data.length === 0) {
				if (item.uri === this.$route.path) {
					newItem.active = true;
				}
			} else {
				item.resource.data.forEach((src) => {
					if (src.uri === this.$route.path || `/${src.uri}` === this.$route.path) {
						newItem.active = true;
					}
				});
				item.resource.data.sort((a, b) => a.position - b.position);
			}
			return newItem;
		}).sort((a, b) => a.position - b.position);
		helper.setLocalData('sidebar', this.items);
		this.$emit('active-route', this.items);
		localStorage.setItem('sidebarApp', JSON.stringify(this.items));
	} catch (err) {
		this.$store.showSnackBar({
			color: 'error',
			text: 'Error interno, recargue la página e intente de nuevo',
		});
	}
}

function data() {
	return {
		drawer: true,
		items: [],
		search: '',
		permsOutdated: false,
	};
}

export default {
	name: 'enhanced-sidebar',
	computed: {
		...mapGetters('user', [
			'userAvatarSideBar',
			'userName',
		]),
		filteredItems,
		inicialUsuario,
		logoWidth,
		nameRoute,
	},
	created,
	beforeDestroy,
	data,
	methods: {
		clearSearch,
		loadData,
		fetchEffectiveResources,
		loadEffectivePermissions,
		applyPermissionFilter,
		checkPermsSync,
		startPermissionWatch,
		stopPermissionWatch,
		reloadNow,
	},
	props: {
		mini: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style lang="scss" scoped>
/* ============================================================
   paleta del menu — turquesa de siempre
   ============================================================ */
$sb-fondo-top: #02979b;
$sb-fondo-mid: #02878b;
$sb-fondo-bottom: #017a7e;
$sb-activo: rgba(255, 255, 255, 0.2);
$sb-activo-suave: rgba(255, 255, 255, 0.15);
$sb-hover: rgba(255, 255, 255, 0.09);
$sb-linea: rgba(255, 255, 255, 0.16);
$sb-texto: rgba(255, 255, 255, 0.88);
$sb-texto-suave: rgba(255, 255, 255, 0.72);

/* ---------- base ---------- */
/* Vuetify le mete un top/margin-top en línea al drawer cuando hay toolbar app.
   Esto lo anula para que el menú empiece en el borde superior. */
.v-navigation-drawer,
.navigation-drawer {
	margin-top: 0 !important;
	max-height: 100% !important;
	top: 0 !important;
}

/* SOLO el aside pinta el fondo. Si la lista tambien lo pinta, su gradiente
   se reinicia dentro del menu y se ve un recuadro mas oscuro alrededor de
   los submenus. Por eso todo lo de adentro va transparente. */
aside,
.navigation-drawer {
	background: linear-gradient(180deg, $sb-fondo-top 0%, $sb-fondo-mid 55%, $sb-fondo-bottom 100%);
}

.sidebar-bg,
.modern-menu-list,
.modern-menu-group,
.list,
.list__group,
.list__group__header,
.list__group__items {
	background: transparent !important;
}

.modern-sidebar-fixed {
	box-shadow: 2px 0 16px rgba(0, 0, 0, 0.16);
}

/* El contenido del drawer en columna: el menú ocupa el alto disponible y hace
   scroll, y el pie del usuario queda abajo SIN encimarse con los ítems. */
.modern-sidebar-fixed ::v-deep .v-navigation-drawer__content {
	display: flex;
	flex-direction: column;
	height: 100%;
}
/* ---------- marca + colapsar ---------- */

.sb-marca {
	align-items: center;
	border-bottom: 1px solid $sb-linea;
	display: flex;
	gap: 10px;
	height: 56px;
	justify-content: space-between;
	padding: 0 12px 0 16px;
}

.sb-marca__logo {
	align-items: center;
	display: flex;
	line-height: 0;
	min-width: 0;
	outline: none;

	img {
		max-height: 34px;
		max-width: 100%;
		object-fit: contain;
	}
}

.sb-marca__toggle {
	align-items: center;
	background: rgba(255, 255, 255, 0.1);
	border: 1px solid $sb-linea;
	border-radius: 9px;
	cursor: pointer;
	display: flex;
	flex: 0 0 32px;
	height: 32px;
	justify-content: center;
	outline: none;
	transition: background-color 0.18s ease;
	width: 32px;

	&:hover {
		background: rgba(255, 255, 255, 0.2);
	}

	.v-icon {
		color: rgba(255, 255, 255, 0.9) !important;
	}

	/* en movil la cabecera ya trae su propio boton */
	@media (max-width: 767px) {
		display: none;
	}
}

.sb-marca--mini {
	flex-direction: column;
	gap: 8px;
	height: auto;
	justify-content: center;
	padding: 10px 0;
}

/* desvanecido sobre el pie, para que la lista no se corte en seco */
/* Ya no se usa: el menú ahora hace scroll propio y el pie queda fijo abajo
   por flex, así que el degradado flotante ya no hace falta. */
.sb-fade {
	display: none;
}

.modern-menu-list {
	flex: 1 1 auto;
	min-height: 0;
	overflow-y: auto;
	padding-bottom: 8px !important;
	padding-top: 2px !important;
	scroll-behavior: smooth;
}

.modern-menu-group {
	margin-bottom: 0;
}

.list {
	&__tile__action {
		justify-content: flex-end;
	}
}

.content-open {
	align-items: center;
	display: flex;
	flex-direction: row;

	.itemName {
		text-transform: none;
	}
}

/* ---------- buscador ---------- */

.sb-buscador {
	padding: 6px 12px 8px;
}

.sb-buscador__caja {
	align-items: center;
	background: rgba(255, 255, 255, 0.12);
	border: 1px solid $sb-linea;
	border-radius: 10px;
	display: flex;
	height: 36px;
	padding: 0 10px;
	transition: background-color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;

	&:focus-within {
		background: rgba(255, 255, 255, 0.2);
		border-color: rgba(255, 255, 255, 0.55);
		box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.12);
	}
}

.sb-buscador__icono {
	color: $sb-texto-suave !important;
	font-size: 17px !important;
	margin-right: 8px;
}

.sb-buscador__input {
	background: transparent;
	border: none;
	color: #ffffff;
	font-family: inherit;
	font-size: 12.5px;
	outline: none;
	width: 100%;

	&::placeholder {
		color: rgba(255, 255, 255, 0.45);
	}
}

.sb-buscador__limpiar {
	align-items: center;
	background: rgba(255, 255, 255, 0.16);
	border: none;
	border-radius: 50%;
	cursor: pointer;
	display: flex;
	flex: 0 0 18px;
	height: 18px;
	justify-content: center;
	outline: none;
	width: 18px;

	&:hover {
		background: rgba(255, 255, 255, 0.28);
	}

	.v-icon {
		color: #ffffff !important;
	}
}

.sb-buscador--mini {
	display: flex;
	justify-content: center;
	padding: 6px 0 8px;
}

.sb-buscador__mini {
	align-items: center;
	background: rgba(255, 255, 255, 0.12);
	border: 1px solid $sb-linea;
	border-radius: 10px;
	cursor: pointer;
	display: flex;
	height: 34px;
	justify-content: center;
	outline: none;
	width: 34px;

	&:hover {
		background: rgba(255, 255, 255, 0.16);
	}

	.v-icon {
		color: rgba(255, 255, 255, 0.8) !important;
	}
}

.sb-seccion {
	color: rgba(255, 255, 255, 0.5);
	font-size: 9.5px;
	font-weight: 700;
	letter-spacing: 1.1px;
	padding: 8px 20px 4px;
	text-transform: uppercase;
}

.sb-vacio {
	align-items: center;
	color: $sb-texto-suave;
	display: flex;
	flex-direction: column;
	font-size: 12px;
	gap: 8px;
	padding: 30px 16px;
	text-align: center;
}

/* ---------- item principal ---------- */

.enhanced-item {
	border-radius: 10px !important;
	color: $sb-texto;
	margin: 2px 8px;
	overflow: hidden;
	position: relative;
	transition: background-color 0.18s ease;

	&:hover {
		background-color: $sb-hover !important;
	}
}

.enhanced-icon-action {
	align-items: center;
	display: flex;
	justify-content: center;
	min-width: 42px !important;
}

.icon-container {
	align-items: center;
	background-color: rgba(255, 255, 255, 0.14);
	border-radius: 9px;
	display: flex;
	flex: 0 0 30px;
	height: 30px;
	justify-content: center;
	transition: background-color 0.2s ease;
	width: 30px;
}

.enhanced-item:hover .icon-container {
	background-color: rgba(255, 255, 255, 0.24);
}

.modern-icon {
	height: 16px;
	opacity: 0.9;
	width: 16px;
}

.enhanced-title {
	font-size: 12.5px;
	font-weight: 600;
	letter-spacing: 0.2px;
}

.enhanced-parent-content {
	align-items: center;
	display: flex;
	justify-content: space-between;
	width: 100%;
}

.enhanced-arrow {
	color: rgba(255, 255, 255, 0.6) !important;
	font-size: 18px !important;
	margin-left: auto;
	transition: transform 0.25s ease;
}

/* la flecha gira cuando el grupo esta ABIERTO, no al pasar el mouse */
.list__group--active .enhanced-arrow {
	color: rgba(255, 255, 255, 0.9) !important;
	transform: rotate(180deg);
}

/* grupo abierto: la cabecera queda levemente marcada */
.list__group--active .modern-parent-item {
	background-color: rgba(255, 255, 255, 0.08);
}

/* ---------- item activo ---------- */

.modern-active {
	background-color: $sb-activo !important;
	box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.22);

	.enhanced-title {
		color: #ffffff !important;
		font-weight: 700;
	}

	.icon-container {
		background-color: rgba(255, 255, 255, 0.34);
	}

	.modern-icon {
		opacity: 1;
	}
}

/* ---------- submenu ---------- */

.resources-items,
.modern-sub-item {
	background-color: transparent !important;
	border-radius: 9px !important;
	cursor: pointer;
	margin: 1px 8px 1px 26px;
	min-height: 36px !important;
	position: relative;
	transition: background-color 0.18s ease;

	/* guia vertical que une los hijos */
	&::before {
		background: $sb-linea;
		bottom: 0;
		content: '';
		left: -12px;
		position: absolute;
		top: 0;
		width: 1px;
	}

	&:hover {
		background-color: $sb-hover !important;
	}
}

.enhanced-sub-action {
	align-items: center;
	display: flex;
	justify-content: center;
	min-width: 26px !important;
}

.title-action,
.modern-dot {
	color: rgba(255, 255, 255, 0.45) !important;
	font-size: 7px !important;
	margin-right: 0;
	position: relative;
	z-index: 1;
}

.modern-sub-item:hover .modern-dot {
	color: rgba(255, 255, 255, 0.7) !important;
}

.enhanced-sub-title {
	color: $sb-texto-suave;
	font-size: 12px;
	font-weight: 500;
	letter-spacing: 0.1px;
}

.modern-sub-active {
	background-color: $sb-activo-suave !important;

	.enhanced-sub-title {
		color: #ffffff;
		font-weight: 600;
	}

	.modern-dot {
		color: #ffffff !important;
		font-size: 9px !important;
	}
}

/* ---------- pie con el usuario ---------- */

.sb-pie {
	align-items: center;
	background: rgba(0, 0, 0, 0.14);
	border-top: 1px solid $sb-linea;
	display: flex;
	flex: 0 0 auto;
	gap: 10px;
	margin-top: auto;
	padding: 10px 14px;
	position: relative;
}

.sb-pie__avatar {
	border-radius: 50%;
	flex: 0 0 34px;
	height: 34px;
	object-fit: cover;
	width: 34px;
}

.sb-pie__avatar--letra {
	align-items: center;
	background: rgba(255, 255, 255, 0.22);
	color: #ffffff;
	display: flex;
	font-size: 14px;
	font-weight: 700;
	justify-content: center;
}

.sb-pie__datos {
	display: flex;
	flex-direction: column;
	min-width: 0;
}

.sb-pie__nombre {
	color: #ffffff;
	font-size: 12.5px;
	font-weight: 600;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.sb-pie__estado {
	align-items: center;
	color: rgba(255, 255, 255, 0.62);
	display: flex;
	font-size: 10.5px;
	gap: 5px;
}

.sb-pie__punto {
	background: #3ddc97;
	border-radius: 50%;
	display: block;
	height: 6px;
	width: 6px;
}

/* ---------- mini variant (menu cerrado) ---------- */

.v-navigation-drawer--mini-variant,
.navigation-drawer--mini-variant {
	.list__tile__action {
		justify-content: center;
	}

	.enhanced-item {
		margin: 2px 6px;
	}

	.enhanced-icon-action {
		margin: 0;
		min-width: 0 !important;
	}

	.resources-items,
	.modern-sub-item {
		margin: 1px 6px;

		&::before {
			display: none;
		}
	}

	.modern-menu-list {
		padding-bottom: 8px !important;
	}
}

/* ---------- scrollbar ---------- */

.modern-menu-list::-webkit-scrollbar,
.modern-sidebar-fixed::-webkit-scrollbar {
	width: 4px;
}

.modern-menu-list::-webkit-scrollbar-track,
.modern-sidebar-fixed::-webkit-scrollbar-track {
	background: transparent;
}

.modern-menu-list::-webkit-scrollbar-thumb,
.modern-sidebar-fixed::-webkit-scrollbar-thumb {
	background: rgba(255, 255, 255, 0.24);
	border-radius: 3px;

	&:hover {
		background: rgba(255, 255, 255, 0.3);
	}
}

/* ============ AVISO: PERMISOS ACTUALIZADOS ============ */
.perms-sync {
	border-radius: 16px !important;
	padding: 28px 26px 26px;
	text-align: center;
}

.perms-sync__icon {
	align-items: center;
	animation: perms-pulse 1.7s ease-in-out infinite;
	background: linear-gradient(135deg, #02979b 0%, #1fd9b6 100%);
	border-radius: 50%;
	box-shadow: 0 6px 16px rgba(2, 151, 155, 0.3);
	display: inline-flex;
	height: 60px;
	justify-content: center;
	margin-bottom: 16px;
	width: 60px;
}

@keyframes perms-pulse {
	0%, 100% { transform: scale(1); }
	50% { transform: scale(1.06); }
}

.perms-sync__title {
	color: #2c404a;
	font-family: map-get($fonts, AvenirBold);
	font-size: 19px;
	font-weight: 700;
	margin: 0 0 8px;
}

.perms-sync__text {
	color: rgba(44, 64, 74, 0.7);
	font-family: map-get($fonts, AvenirRegular);
	font-size: 13px;
	line-height: 1.55;
	margin: 0 auto 22px;
	max-width: 330px;
}

.perms-sync__actions {
	display: flex;
	justify-content: center;
}

.perms-sync__btn {
	align-items: center;
	background: linear-gradient(135deg, #02979b 0%, #028a94 100%);
	border: 0;
	border-radius: 10px;
	color: #fff;
	cursor: pointer;
	display: inline-flex;
	font-family: map-get($fonts, AvenirBold);
	font-size: 14px;
	font-weight: 600;
	gap: 8px;
	justify-content: center;
	min-width: 190px;
	padding: 11px 26px;
	transition: transform 0.15s ease, box-shadow 0.15s ease;

	&:hover {
		box-shadow: 0 6px 16px rgba(2, 151, 155, 0.3);
		transform: translateY(-1px);
	}

	&:active {
		transform: translateY(0);
	}
}
</style>


// WEBPACK FOOTER //
// src/components/shared/app-sidebar.vue